<mat-sidenav-container class="sidenav-container">

    <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="isHandset ? 'dialog' : 'navigation'"
        [mode]="isHandset ? 'over' : 'side'" [opened]="!isHandset">

        <div class="nav-header">
            <div class="brand">
                <mat-icon>search</mat-icon>
                <span>Search System</span>
            </div>
        </div>

        <mat-nav-list>
            <a mat-list-item routerLink="/dashboard" routerLinkActive="active-link"
                (click)="isHandset ? drawer.close() : null">
                <mat-icon mat-list-icon>dashboard</mat-icon>
                <span mat-line>検索</span>
            </a>

            <a mat-list-item routerLink="/users" routerLinkActive="active-link"
                (click)="isHandset ? drawer.close() : null">
                <mat-icon mat-list-icon>people</mat-icon>
                <span mat-line>ユーザー管理</span>
            </a>

            <a mat-list-item routerLink="/settings" routerLinkActive="active-link"
                (click)="isHandset ? drawer.close() : null">
                <mat-icon mat-list-icon>settings</mat-icon>
                <span mat-line>設定</span>
            </a>
        </mat-nav-list>

    </mat-sidenav>

    <mat-sidenav-content>

        <mat-toolbar class="top-toolbar">
            <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
                *ngIf="isHandset">
                <mat-icon>menu</mat-icon>
            </button>

            <div class="page-title" *ngIf="!isHandset">Dashboard</div>

            <span class="spacer"></span>

            <button mat-icon-button *ngIf="!isHandset">
                <mat-icon>apps</mat-icon>
            </button>

            <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-avatar-btn">
                <mat-icon class="avatar-icon">account_circle</mat-icon>
            </button>

            <mat-menu #userMenu="matMenu">
                <div class="user-info-panel" *ngIf="user">
                    <div class="name">{{ user.name }}</div>
                    <div class="email">{{ user.email }}</div>
                </div>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="onLogout()">
                    <mat-icon>logout</mat-icon>
                    <span>Sign out</span>
                </button>
            </mat-menu>
        </mat-toolbar>

        <div class="content-body">
            <router-outlet></router-outlet>
        </div>

    </mat-sidenav-content>

</mat-sidenav-container>